import { t } from "ttag";

import type { Credit } from "@/features/referral/models";
import { creditSchema } from "@/features/referral/models";
import { ReferralStatBanner } from "./stat-banner";

const statusValue = creditSchema
  .pick({ pending: true, available: true })
  .keyof().enum;

interface ReferralStatsProps {
  credit: Credit;
}

export const ReferralStats = ({ credit }: ReferralStatsProps) => {
  const LABELS = {
    [statusValue.pending]: t`Pending credit`,
    [statusValue.available]: t`Available credit`,
  };

  const DETAILS = {
    [statusValue.pending]: t`Credit earned, available after your referral has been an active member for 30 days.`,
    [statusValue.available]: t`Credit ready to manually apply to your next invoice or store purchase.`,
  };

  return (
    <div className="flex flex-col gap-3 md:flex-row">
      {Object.values(statusValue).map((stat) => (
        <ReferralStatBanner
          key={stat}
          value={credit[stat]}
          label={LABELS[stat]}
          detail={DETAILS[stat]}
        />
      ))}
    </div>
  );
};
